<template>
  <v-container fluid class="pa-0">
    <v-container class="header" fluid>
      <v-layout column align-center justify-center>
        <v-col xl="12" lg="12" md="12" sm="12" class="pb-0">
          <v-layout align-center style="height: 130px">
            <v-layout row style="position: absolute">
              <v-img
                @click="goBack()"
                height="45"
                width="45"
                class="shrink pointer"
                contain
                :src="require('../../assets/back.png')"
              />
              <div class="ml-3" style="color: #fff; width: 96px">Back to profuse.md</div>
            </v-layout>
            <v-col xl="8" lg="9" md="12" sm="12" class="pb-0 mx-auto">
              <Toolbar />
            </v-col>
          </v-layout>
        </v-col>

        <v-col xl="8" lg="10" md="10" sm="10">
          <v-layout row justify-space-between>
            <v-col lg="5" md="6" sm="12" class="align-self-center">
              <v-layout column>
                <div class="app-title">The most sticky puzzle game</div>
                <div
                  class="app-description"
                >The game is not for kids only, it’s a game for all ages and mindsets. This preset collection stands out due to it’s natural radiant colors, nice greens and healthy skintones.</div>

                <v-row class="mt-9 pt-5">
                  <v-flex shrink mr-9 mb-5 class="pointer">
                    <v-img
                      @click="openAppStore"
                      height="58"
                      width="195"
                      contain
                      :src="require('../../assets/app_store.png')"
                    />
                  </v-flex>
                </v-row>
              </v-layout>
            </v-col>

            <v-col lg="6" md="6" sm="8" class="align-self-center header-screenshot">
              <v-img contain :src="require('../../assets/Puzzle/screenshot1.png')" />
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="content" fluid>
      <v-layout column align-center>
        <v-col xl="6" lg="8" md="9" sm="10">
          <div class="content-title">Feel the best experience with our Brain Puzzle App</div>
        </v-col>

        <v-col xl="6" lg="8" md="10" sm="12">
          <v-layout justify-center>
            <v-layout row justify-space-between>
              <v-col md="3" sm="12">
                <v-img height="112" contain :src="require('../../assets/Puzzle/brain_icon.png')" />
                <div class="item-title">Different levels of difficulty</div>
                <div
                  class="item-description"
                >This preset collection stands out due to it’s natural radiant colors, nice greens and healthy skintones.</div>
              </v-col>

              <v-col md="3" sm="12">
                <v-img height="112" contain :src="require('../../assets/Puzzle/puzzle_icon.png')" />
                <div class="item-title">A lot of puzzle categories</div>
                <div
                  class="item-description"
                >This preset collection stands out due to it’s natural radiant colors, nice greens and healthy skintones.</div>
              </v-col>

              <v-col md="3" sm="12">
                <v-img height="112" contain :src="require('../../assets/Puzzle/phone_icon.png')" />
                <div class="item-title">iOS and Android platforms</div>
                <div
                  class="item-description"
                >This preset collection stands out due to it’s natural radiant colors, nice greens and healthy skintones.</div>
              </v-col>
            </v-layout>

            <v-col xl="5" lg="6" md="7" class="item-devider-container hidden-sm-and-down">
              <v-layout>
                <v-img
                  class="left-item-devider"
                  width="200"
                  height="30"
                  contain
                  :src="require('../../assets/Puzzle/devider_up.png')"
                />
                <v-img
                  class="right-item-devider"
                  width="200"
                  height="30"
                  contain
                  :src="require('../../assets/Puzzle/devider_down.png')"
                />
              </v-layout>
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="make-your-brain" fluid>
      <v-layout row justify-center>
        <v-col xl="8" lg="10" md="10" sm="10">
          <v-layout row>
            <v-col md="7" sm="10" align-self="center">
              <v-img contain :src="require('../../assets/Puzzle/screenshot2.png')" />
            </v-col>

            <v-col md="5" sm="10" align-self="center">
              <div class="content-title text-left mx-9 mt-9">Make your brain work faster</div>
              <div
                class="item-description text-left mx-9 mb-9 pb-9"
              >The game is not for kids only, it’s a game for all ages and mindsets. This preset collection stands out due to it’s natural radiant colors, nice greens and healthy skintones.</div>
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="footer" fluid>
      <v-layout justify-center>
        <v-col xl="8" lg="10" md="10" sm="10" class="footer-bg">
          <v-layout row justify-center>
            <v-col md="7" sm="12" align-self="center">
              <div class="footer-title mx-9">Download the Free Brain Puzzle App</div>
              <v-row class="mt-9 pt-5 ml-9">
                <v-flex shrink mr-9 mb-5 class="pointer">
                  <v-img
                    @click="openAppStore"
                    height="58"
                    width="195"
                    contain
                    :src="require('../../assets/app_store.png')"
                  />
                </v-flex>
              </v-row>
            </v-col>

            <v-col md="5" class="footer-image hidden-sm-and-down">
              <v-img contain height="736" :src="require('../../assets/Puzzle/screenshot3.png')" />
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-layout justify-center>
        <v-col xl="8" lg="10" md="10" sm="10">
          <v-toolbar color="transparent" height="100" flat>
            <v-flex shrink align-center justify-center class="logo">
              <v-img
                height="100"
                width="100"
                contain
                :src="require('../../assets/Puzzle/logo.png')"
              />
            </v-flex>
            <v-spacer></v-spacer>

            <v-layout row justify-end>
              <v-btn :dark="theme == 'dark' ? false : true" text>
                <div class="toolbar-btn" :style="{ color: 'black' }">How it Use</div>
              </v-btn>

              <v-btn :dark="theme == 'dark' ? false : true" text>
                <div class="toolbar-btn" :style="{ color: 'black' }">Privacy Policy</div>
              </v-btn>
            </v-layout>
          </v-toolbar>
        </v-col>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import Toolbar from "./components/Toolbar";
export default {
  components: {
    Toolbar
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openAppStore() {
      window.open(
        "https://apps.apple.com/us/app/brain-puzzle-challenge/id1506175447",
        "_blank"
      );
    }
  }
};
</script>

<style scoped>
.header {
  background-image: url("../../assets/Puzzle/bg_header.png");
  background-size: cover;
}
.pointer {
  cursor: pointer;
}
.app-title {
  font-family: "Merriweather";
  font-size: 5vh;
  font-weight: bold;
  line-height: 1.26;
  text-align: left;
  color: #88c9b3;
}
.app-description {
  font-family: "SFProText";
  font-size: 16px;
  font-weight: 500;
  line-height: 1.88;
  text-align: left;
  color: #ffffff;
  margin-top: 25px;
}
.header-screenshot {
  margin-bottom: -150px;
}
.content {
  margin-top: 120px;
}
.content-title {
  font-family: "Merriweather";
  font-size: 5vh;
  font-weight: bold;
  line-height: 1.25;
  text-align: center;
  color: #88c9b3;
}
.item-title {
  font-family: "Merriweather";
  font-size: 24px;
  font-weight: bold;
  line-height: 1.29;
  text-align: center;
  color: #5f5e64;
}
.item-description {
  font-family: "SFProText";
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  color: #b4b4b4;
}
.left-item-devider {
  margin-top: 20px;
}
.right-item-devider {
  margin-top: 50px;
}
.item-devider-container {
  position: absolute;
}
.make-your-brain {
  margin-top: 80px;
}
.footer-bg {
  border-radius: 32px;
  background-color: #f08d66;
  margin-top: 100px;
  margin-bottom: 100px;
}
.footer-title {
  font-family: "Merriweather";
  font-size: 5vh;
  font-weight: bold;
  line-height: 1.25;
  text-align: left;
  color: #ffffff;
}
.footer-image {
  margin-top: -150px;
  margin-bottom: -150px;
}
.toolbar-btn {
  font-family: "Montserrat";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #fafafa;
  text-transform: none;
}
</style>